/**
* Endpoint methods related to Stripe communication in the back-end
*/
import API from "./Api";


export default {
    /**
    * Creates an acccount link for onboarding Stripe Connected Accounts
    */
    async createAccountLink(form) {

        return API.post("/stripe/createaccountlink", form, "MOODLE_SESSION_JSON");
      },

    /**
    * Creates a Stripe payment intent 
    */
    async createPaymentIntent(form){
      return API.post("/stripe/createpaymentintent", form, "PLAIN_JSON");
    },

    /**
    * Creates a Stripe Checkout Session
    */
    async createCheckoutSession(form){
      return API.post("/stripe/createcheckoutsession", form, "PLAIN_JSON");
    }
    
}